import { SascEmailConfigModel } from "./user";

const PREFIX = "USER";

export interface GetUserPayload {
  userId: string;
  queryParams?: any;
}

export class GET_USER {
  public static readonly type = `[${PREFIX}] GET USER`;
  constructor(public readonly payload: GetUserPayload) {}
}

export class GET_MENU {
  public static readonly type = `[${PREFIX}] GET MENU`;
  constructor(public readonly payload: string) {}
}

export class RESET_QUERY_PARAMS {
  public static readonly type = `[${PREFIX}] RESET QUERY PARAMS`;
}

export class POPULATE_POLICY_MANAGEMENT {
  public static readonly type = `[${PREFIX}] POPULATE POLICY MANAGEMENT`;
}

export class LOGOUT {
  public static readonly type = `[${PREFIX}] LOGOUT`;
}

export class NAVIGATE_LOGIN_PAGE {
  public static readonly type = `[${PREFIX}] NAVIGATE LOGIN PAGE`;
}

export class STORE_QUERY_PARAMS {
  public static readonly type = `[${PREFIX}] STORE QUERY PARAMS`;
  constructor(public readonly payload: any) {}
}

export class RESTORE_AUTH_SESSION {
  public static readonly type = `[${PREFIX}] RESTORE AUTH SESSION`;
  constructor(public readonly payload?: { queryParams?: any }) {}
}

export class GET_SASC_EMAIL_CONFIG {
  public static readonly type = `[${PREFIX}] GET SASC EMAIL CONFIG`;
  constructor(public readonly payload: string) {}
}

export class SAVE_SASC_EMAIL_CONFIG {
  public static readonly type = `[${PREFIX}] SAVE SASC EMAIL CONFIG`;
  constructor(public readonly payload: Partial<SascEmailConfigModel>) {}
}

export class LOGIN {
  public static readonly type = `[${PREFIX}] LOGIN`;
  constructor(public readonly payload) {}
}

export class RESET_LOGIN_RESPONSE {
  public static readonly type = `[${PREFIX}] RESET LOGIN RESPONSE`;
}

export class SAVE_USER_VALIDATION {
  public static readonly type = `[${PREFIX}] SAVE USER VALIDATION`;
  constructor(public readonly payload) {}
}

export class SET_LOGGED_IN_STATE {
  public static readonly type = `[${PREFIX}] SET LOGGED IN STATE`;
}

export class RESET_SECRET_ANSWER {
  public static readonly type = `[${PREFIX}] RESET SECRET ANSWER STATE`;
}

export class SUBMIT_VALIDATION_QUESTION {
  public static readonly type = `[${PREFIX}] SUBMIT VALIDATION QUESTION`;
  constructor(public readonly payload) {}
}

export class SUBMIT_FIRST_TIME_LOGIN {
  public static readonly type = `[${PREFIX}] SUBMIT FIRST TIME LOGIN`;
  constructor(public readonly payload) {}
}

export class RESET_PASSWORD {
  public static readonly type = `[${PREFIX}] RESET PASSWORD`;
  constructor(public readonly payload) {}
}

export class GET_SECRET_QUESTION {
  public static readonly type = `[${PREFIX}] GET SECRET QUESTION`;
  constructor(public readonly payload) {}
}

export class SUBMIT_RESET_PASSWORD {
  public static readonly type = `[${PREFIX}] SUBMIT RESET PASSWORD`;
  constructor(public readonly payload) {}
}

export class RESET_SECRET_QUESTION {
  public static readonly type = `[${PREFIX}] RESET SECRET QUESTION`;
}

export class TOGGLE_ADMINISTRATOR_BTN {
  public static readonly type = `[${PREFIX}] TOGGLE ADMINISTRATOR BTN`;
}

export class RESET_DASHBOARD_STATE {
  public static readonly type = `[${PREFIX}] RESET DASHBOARD STATE`;
}

export class UPDATE_PREFER_NAME {
  public static readonly type = `[${PREFIX}] UPDATE PREFER NAME`;
  constructor(public readonly payload) {}
}

export class SET_IS_PASSWORD_EXPIRING_IND {
  public static readonly type = `[${PREFIX}] SET IS PASSWORD EXPIRING IND`;
  constructor(public readonly payload: boolean) {}
}

export class SET_IS_PASSWORD_EXPIRED_IND {
  public static readonly type = `[${PREFIX}] SET IS PASSWORD EXPIRED IND`;
  constructor(public readonly payload: boolean) {}
}
